import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import moment from "moment";
import { useEffect } from "react";
import ColourField from "../common/colour.field";
import DateField from "../common/date.field";
import { useForm } from "../common/form.util";

export default function SchoolForm(props) {
	const formCtx = useForm(props.school, props);
	let school = formCtx?.data;

	useEffect(() => {
		formCtx.setData(props.school);
	}, [props.school]);

	let birthDate = school?.birthDate ? moment(school.birthDate) : null;

	return (
		<Stack direction="column" sx={props.sx}>
			<TextField label="School Name" variant="standard" value={school?.name || ''} onChange={(e) => formCtx.onChange(e, 'name')} required autoFocus />
		</Stack>
	);
}